<script setup lang="ts">
const emit = defineEmits(['click'])

defineProps({
  text: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
  isInteractive: {
    type: Boolean,
    default: false,
  },
})

const isVisible = ref(true)

const onToggle = () => {
  isVisible.value = !isVisible.value
  emit('click', isVisible.value)
}
</script>

<template>
  <button
    class="flex cursor-pointer items-center gap-2 text-left text-xs"
    :class="{ 'line-through': isInteractive && !isVisible }"
    data-testid="chart-legend-item"
    @click.prevent.stop="onToggle"
  >
    <span
      class="h-[5px] w-[15px] shrink-0"
      :style="{ 'background-color': color }"
    />
    {{ text }}
  </button>
</template>
